export const Events = {
  path: '/events',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'events',
      component: () => import('pages/events/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'イベント一覧',
      },
    },
    {
      path: ':id',
      name: 'events-id',
      component: () => import('pages/events/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          { title: 'イベント一覧', path: '/events', condition: 'event' },
        ],
      },
    },
  ],
};
